<template>
	<div id="intro" :class="{ 'side-opened': sideOpened, 'night-mode': nightMode }">
		<div>
			<template v-if="$i18n.locale === 'cs'">
				<h2>Vítej ve svém Mango zpěvníku!</h2>
				<ul>
					<li><strong>V levé liště máš seznam písniček</strong>, které máš ve zpěvníku aktuálně uložené.</li>
					<li><strong>Pár jsem ti jich předpřipravil.</strong> Můžeš si je samozřejmě promazat, a vložit ty které chceš.</li>
					<li>Chceš <strong>vyhledat a přidat další písničku?</strong> Otevři menu pomocí přepínače vlevo nahoře. A vyber "<em>Přidat písničku</em>".</li>
				</ul>

				<p>
					Máš nějakou otázku nebo si našel chybu? Napiš mi, prosím, na e-mail <a href="mailto:adam@motvicka.cz">adam@motvicka.cz</a>.
				</p>
			</template>
			<template v-if="$i18n.locale === 'en'">
				<h2></h2>
			</template>

			<div id="mobile-store-icons" v-if="device && device.platform === 'web'">
				<a href="https://itunes.apple.com/us/app/mango-zpěvn%C3%ADk/id1462046181" target="_blank">
					<img src="/images/appstore.svg">
				</a>
				<a href="https://play.google.com/store/apps/details?id=com.motvicka.mangosongbook" target="_blank">
					<img src="/images/googleplay.svg">
				</a>
				<br><br><br><br>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState } from "vuex";
	export default {
		data() {
			return {
				touch: {
					firstTouch: null,
					panning: null
				}
			}
		},
		computed: {
			...mapState([ "sideOpened", "device", "nightMode" ])
		},
		methods: {
			touchStart(e) {
				this.touch.firstTouch = e;
			},
			touchMove(e) {
				if (e.touches.length === 1) {
					if (this.touch.firstTouch.touches[0].clientX < 40) {
						var pulled = e.changedTouches[0].clientX - this.touch.firstTouch.touches[0].clientX;
						this.$store.commit("setSidePulled", pulled > 260 ? 260 : pulled);
						document.dispatchEvent(new Event("PullingSide"));
					}
				}
			},
			touchEnd(e) {
				this.$store.commit("setSidePulled", 0);
				var validTouch = this.touch.firstTouch !== null && e.changedTouches.length > 0;

				var deltaX = validTouch ? (e.changedTouches[0].clientX - this.touch.firstTouch.touches[0].clientX) : 0;
				var deltaY = validTouch ? (e.changedTouches[0].clientY - this.touch.firstTouch.touches[0].clientY) : 0;

				if (this.touch.firstTouch.touches[0].clientX < 20) {
					var pulled = e.changedTouches[0].clientX - this.touch.firstTouch.touches[0].clientX;
					if (pulled > 120) this.$store.commit("setSideOpened", true);
					document.dispatchEvent(new Event("PullingSide"));
				} else if (Math.abs(deltaX) < 5 && Math.abs(deltaY) < 5) {
					if (this.sideOpened) {
						this.$store.commit("setSideOpened", false);
					}
				}
			}
		},
		mounted() {
			this.$el.addEventListener("touchstart", this.touchStart);
			this.$el.addEventListener("touchmove", this.touchMove);
			this.$el.addEventListener("touchend", this.touchEnd);
		},
		destroy() {
			this.$el.removeEventListener("touchstart", this.touchStart);
			this.$el.removeEventListener("touchmove", this.touchMove);
			this.$el.removeEventListener("touchend", this.touchEnd);
		},
	}
</script>

<style lang="scss" scoped>
	#intro {
		margin: 0;
		padding: 20px;
		position: fixed;
		top: 50px;
		top: calc(constant(safe-area-inset-top) + 50px);
		top: calc(env(safe-area-inset-top) + 50px);
		left: 0;
		width: calc(100vw - 40px);
		height: 100%;
		overflow-y: auto;
		overflow-x: hidden;
		white-space: nowrap;
		-webkit-overflow-scrolling: touch;
		background-color: #eeeeee;
		z-index: -1;

		transition: left 0.2s, width 0.2s, background-color 0.5s, color 0.5s;

		line-height: 1.8em;

		&.night-mode {
			background-color: #323a40;
			color: rgba(255, 255, 255, 0.75);

			a {
				color: rgb(211, 177, 97);
				text-decoration: underline;

				&:hover {
					color: rgb(133, 113, 58);
				}
			}
		}

		&.side-opened {
			left: 260px;
			width: calc(100vw - 300px);
		}

		div {
			width: 100%;
			min-width: 280px;
			white-space: normal;

			ul {
				margin: 0;
				padding-left: 30px;

				li {
					margin: 0;
					padding: 0;
				}

				strong {
					font-weight: 600;
				}
			}
		}

		a {
			color: rgb(133, 113, 58);
			text-decoration: underline;

			&:hover {
				color: rgb(211, 177, 97);
			}
		}

		#mobile-store-icons {
			margin: 30px 0 10px 0;

			img {
				height: 62px;
				margin: 0;

				&:first-child {
					margin-right: 20px;
				}
			}
		}
	}
</style>
